var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartBase',{attrs:{"title":"Top Products","loading":_vm.loading}},[_c('PieChart',{ref:"pie",staticClass:"chart-thirty-day-top-products",attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }